import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'fgb-popup-info',
  templateUrl: './popup-info.component.html',
  styleUrls: ['./popup-info.component.scss']
})
export class PopupInfoComponent implements OnInit {

  @Input() description: string;
  @Input() image: string;

  constructor() { }

  ngOnInit() {
  }

}
